import i18n from '../i18n';

const { t } = i18n.global;

const MOBILE_SCREEN_WIDTH = 414;
const DESKTOP_SCREEN_WIDTH = 1024;

const CHECKBOX_COLORS = {
    GOLD: 'gold',
    SUCCESS: 'success'
};

const SIDEBAR_COLORS = {
    AQUA: 'aqua',
    PERIWINKLE: 'periwinkle'
};

const REGEX = {
    ALL_EXCEPT_DASHES_AND_ALPHANUMERIC_CHARACTERS: /[^a-zA-Z0-9-]/g,
    ALL_EXCEPT_DASHES_UNDERSCORES_AND_ALPHANUMERIC_CHARACTERS: /[^a-zA-Z0-9-_]/g,
    ALL_EXCEPT_DASHES_SPACES_AND_ALPHANUMERIC_CHARACTERS: /[^a-zA-Z0-9-\s]/g,
    ALL_EXCEPT_DASHES_UNDERSCORES_SPACES_AND_ALPHANUMERIC_CHARACTERS: /[^a-zA-Z0-9-_ ]/g,
    DASHES_AT_BEGINNING_AND_END: /^-+|-+$/g,
    MULTIPLE_DASHES: /-+/g,
    WHITESPACE: /\s/g
};

const S3_COMMANDS = {
    HEAD: 'HeadObject',
    PUT: 'PutObject',
    DELETE: 'DeleteObject'
};

const IMAGE_FILE_SIZES = {
    '1MB': {
        bytes: 1048576,
        errorMessage: t('forms.validation.imageSize', { size: '1MB' })
    },
    '500KB': {
        bytes: 524288,
        errorMessage: t('forms.validation.imageSize', { size: '500KB' })
    }
};

const DATA_TABLE_PAGE_LENGTH_OPTIONS = ['20', '50', '100', '250', 'All'];
const DATATABLE_INFINITE_SCROLL_CHUNK_SIZE = 500;

const FILE_TYPES = {
    CSV: 'csv',
    PDF: 'pdf'
};

const CONTRIBUTION_REPORT_MODES = {
    STATEMENT: 'Statement',
    RECEIPT: 'Receipt',
    DOWNLOAD :'Download'
} as const;

export {
    MOBILE_SCREEN_WIDTH,
    DESKTOP_SCREEN_WIDTH,
    CHECKBOX_COLORS,
    SIDEBAR_COLORS,
    REGEX,
    IMAGE_FILE_SIZES,
    S3_COMMANDS,
    DATA_TABLE_PAGE_LENGTH_OPTIONS,
    DATATABLE_INFINITE_SCROLL_CHUNK_SIZE,
    FILE_TYPES,
    CONTRIBUTION_REPORT_MODES
};
